<template>
<div class="text-h4 font-weight-medium header-container">
    <div class="header-container--left">
        <v-btn
            v-if="props.showLeadingBtn"
            variant="text"
            @click="emit('on-leading-btn-click')"
        >
            <font-awesome-icon :icon="props.leadingIcon" size="2x"/>
        </v-btn>

        {{ props.title }}
    </div>

    <div>
        <v-btn
          v-if="props.showSecondaryTrailingBtn"
          class="mr-2"
          variant="text"
          @click="emit('on-secondary-btn-click')"
        >
          <font-awesome-icon :icon="props.secondaryTrailingIcon"/>
      </v-btn>

      <v-btn
          v-if="isSignedIn && isAdmin && props.showTrailingBtn && !props.showProgress"
          variant="tonal"
          @click="emit('on-click')"
      >
          <font-awesome-icon :icon="props.trailingIcon"/>
      </v-btn>

      <v-progress-circular
        v-else-if="props.showProgress"
        indeterminate
        color="primary"/>
    </div>
</div>

<v-divider class="mt-2 mb-2"/>
</template>

<style scoped lang="scss">
  .header-container {
    display: flex !important;
    flex-direction: row !important;
    align-items: center !important;
    justify-content: space-between !important;

    &--left {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-start;
      vertical-align: middle;
      align-content: center;
    }
  }
</style>

<script lang="ts" setup>
import { useAuthStore } from '@/stores/AuthStateStore'
import { storeToRefs } from 'pinia'

const props = defineProps({
  title: String,
  showLeadingBtn: {
    type: Boolean,
    default: false
  },
  leadingIcon: {
    type: String,
    default: 'fa-solid fa-arrow-left'
  },
  showSecondaryTrailingBtn: {
    type: Boolean,
    default: false
  },
  secondaryTrailingIcon: {
    type: String,
    default: 'fa-solid fa-chevron-down'
  },
  showTrailingBtn: {
    type: Boolean,
    default: true
  },
  trailingIcon: {
    type: String,
    default: 'fa-solid fa-add'
  },
  showProgress: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['on-click', 'on-leading-btn-click', 'on-secondary-btn-click'])
const { isSignedIn, isAdmin } = storeToRefs(useAuthStore())

</script>
